<template>
  <div class="radio-list__radio">
    <label>
      <input
        type="radio"
        autocomplete="off"
        :required="required"
        :disabled="disabled"
        :name="name"
        :value="value"
        :checked="isChecked"
        v-model="computedLocalChecked"
      />
      <slot>{{ label }}</slot>
    </label>
  </div>
</template>
<script>
import { looseEqual } from "../../../utils";
import { formMixin, formRadioCheckMixin } from "../../../mixins";
export default {
  mixins: [formMixin, formRadioCheckMixin],

  /*
	watch: {
		'value': function(newValue, oldValue){
			this.$emit('input', newValue);
		}
	},*/

  methods: {
    emitChange({ target: { checked } }) {
      this.$emit("change", checked ? this.value : null);
    },

    selectOption(event) {
      this.radioButtonValue = event;
    }
  }
};
</script>
